export const sorting = {
    'sort.newest': 'Newest',
    'sort.price': 'Price',
    'sort.on.sale': 'On Sale',
    'sort.number': 'Number',
}
